/* eslint-disable react-refresh/only-export-components */
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { CreatePurchaseOrderContent } from '@/app/(client)/orders/-components/CreatePurchaseOrderContent';
import { useCreatePurchaseOrderPage } from '@/app/(client)/orders/-hooks/useCreatePurchaseOrderPage';

export const Route = createFileRoute(
  '/(client)/orders/(pages)/(create)/purchase-orders/create/',
)({
  validateSearch: (search: Record<string, unknown>) => ({
    step:
      typeof search.step === 'number' && search.step >= 1 && search.step <= 3
        ? (search.step as 1 | 2 | 3)
        : 1,
    nodeId: typeof search.nodeId === 'string' ? search.nodeId : undefined,
  }),
  component: CreatePurchaseOrderCreatePage,
});

function CreatePurchaseOrderCreatePage() {
  const navigate = useNavigate({ from: Route.fullPath });
  const { step, nodeId } = Route.useSearch();
  const currentStep = step ?? 1;

  function setStep(s: number) {
    void navigate({ search: { step: s as 1 | 2 | 3, nodeId }, replace: false });
  }

  const pageProps = useCreatePurchaseOrderPage(
    currentStep,
    undefined,
    setStep,
    nodeId,
  );
  const { form } = pageProps;

  useEffect(() => {
    if (currentStep > 1 && !form.getValues('supplierId')) {
      void navigate({ search: { step: 1, nodeId }, replace: true });
    }
  }, [currentStep, form, navigate, nodeId]);

  return (
    <CreatePurchaseOrderContent {...pageProps} currentStep={currentStep} />
  );
}
